<template>
  <div style="height: 100%;overflow: auto;">
    <Nav :msg="msg" :nav="nav"></Nav>
    <div style="display: flex;margin: 20px auto;">
      <el-input v-model="keyword" placeholder=标题名称 style="width: 250px;"></el-input>
      <el-button type="primary" @click="get_list" style="margin-left: 10px;">搜索</el-button>
    </div>
    <div class="mt-20">
      <el-table :data="list" border stripe row-style="max-height:100px;">
        <el-table-column label="ID" prop="id" width="50px"></el-table-column>
        <el-table-column label="绑定微信用户">
          <template v-slot="scope">
            <div class="wx-user" v-if="scope.row.user">
              <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.user.avatarurl+')' }"></div>
              <el-popconfirm title="确认操作？" @confirm="unbind_user(scope.row.id)">
                <el-button type="text" style="margin-left: 10px;" size="mini" slot="reference">取消绑定</el-button>
              </el-popconfirm>
            </div>
            <div class="">{{scope.row.user.nickname}}</div>
            <div class="wx-user" v-if="!scope.row.user">
              <el-tag type="info" size="mini">未绑定用户</el-tag>
              <el-button type="text" style="margin-left: 10px;" @click="bind_user(scope.row.id)">绑定</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建用户">
          <template v-slot="scope">
            <div class="wx-user" v-if="scope.row.creater">
              <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.creater.avatarurl+')'}"></div>
            </div>
            <div class="">{{scope.row.creater.nickname}}</div>
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="封面" >
          <template v-slot="scope">
            <div class="wx-user">
              <div class="cover" :style="{ backgroundImage:'url('+scope.row.cover+')' }"></div>
            </div>
          </template>
        </el-table-column>
<!--        <el-table-column label="可用次数" prop="num">-->
<!--          <template v-slot="scope">-->
<!--            <el-tag type="text" size="small">{{scope.row.num}}</el-tag>-->
<!--            <el-button slot="reference" type="danger" size="mini" style="margin-left: 10px;"-->
<!--                       @click="send(scope.row.id)">赠送-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <!--      <el-table-column label="接收信息" prop="is_message">
                <template v-slot="scope">
                  <el-tag type="success" v-if="scope.row.is_message == 1">接收</el-tag>
                  <el-tag type="info" v-if="scope.row.is_message == 0">不接收</el-tag>
                </template>
              </el-table-column>-->
        <el-table-column label="显示状态" prop="is_show">
          <template v-slot="scope">
            <el-tag type="success" size="small" v-if="scope.row.is_show==0">下架中</el-tag>
            <el-tag type="danger" size="small" v-if="scope.row.is_show==1">上架中</el-tag>

            <template v-if="scope.row.is_show ==0">
              <el-popconfirm title="确定上架？" @confirm="show(scope.row.id,'1')">
                <el-button slot="reference" type="danger" size="mini" class="ml-10" style="margin-left: 10px;">上架
                </el-button>
              </el-popconfirm>
            </template>
            <template v-if="scope.row.is_show ==1">
              <el-popconfirm title="确定下架？" @confirm="show(scope.row.id,'0')">
                <el-button type="success" size="mini" slot="reference" class="ml-10" style="margin-left: 10px;">下架
                </el-button>
              </el-popconfirm>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="addtime"></el-table-column>
<!--        <el-table-column label="操作时间" prop="lasttime"></el-table-column>-->
        <el-table-column label="操作" width="220px">
          <template v-slot="scope">
            <el-button type="primary" @click="page_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑
            </el-button>
            <el-button type="success" @click="form_show(scope.row.id,scope.row.form_content)" size="small"
                       style="margin-right: 10px;">表单
            </el-button>
            <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
              <el-button type="danger" size="small" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
    <div class="bg" v-if="is_bind">
      <div class="wrap">
        <div class="pop-title-closed">
          <div class="pop-title">绑定用户</div>
          <div class="pop-closed iconfont icon-close" @click="pop_close"></div>
        </div>
        <div class="contain">
          <div class="image"><img :src="qrcode_url" alt="" mode="widthFix"/></div>
          <div style="text-align: center;margin-bottom: 20px;">微信扫一扫</div>
          <div class="save" @click="qrcode_save(qrcode_url)">保存图片</div>
        </div>
      </div>
    </div>
    <LayerPop title="添加/编辑表单" @close="vue_pop_show_hide" v-if="is_pop">
      <el-button type="primary" round size="medium" @click="add">添加项目</el-button>
      <el-table :data="form_content" border stripe style="margin: 20px auto">
        <el-table-column label="名称" >
          <template v-slot="scope">
            <el-input type="text" v-model.number="scope.row.title" placeholder="名称"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="提示" >
          <template v-slot="scope">
            <el-input type="text" v-model.number="scope.row.tip" placeholder="提示"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="类型" >
          <template v-slot="scope">
            <el-select v-model="scope.row.type" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" >
          <template v-slot="scope">
            <el-popconfirm title="确定删除此行？" @confirm="del_form(scope.$index)">
              <el-button size="mini" type="danger" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" size="medium" @click="save">确认保存</el-button>
    </LayerPop>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import LayerPage from "@/components/layer-page";
import LayerPop from "@/components/layer-pop";

export default {
name: "list",
  components:{
  Nav,LayerPage,LayerPop
  },
  data(){
    return{
      msg: 'one_page',
      nav:[
        {name:'单页列表',path:'one_page'},
        {name:'添加 / 编辑单页',path:'one_page_detail'},
        // {name:'单页分类',path:'one_page_sort'},
      ],
      list:[],
      is_load:false,
      page:1,
      total:0,
      is_bind:false,
      is_pop:false,
      form_content: [],
      options:[
          {value: 'text',label: '文本'},
          {value: 'phone',label: '手机号'},
          {value: 'img',label: '图片'},
      ],
      id:0,
      keyword:''
    }
  },
  mounted:async function (){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    form_show(id,form_content){
      console.log(id);
      console.log(form_content);
      this.is_pop = true;
      this.id = id;
      this.form_content = form_content;
    },
    del_form:function (index){
      console.log(index);
      this.form_content.splice(index,1);
    },
    add: function (){
      let data = {title:'',type:'text',tip:'',value:''};
      this.form_content.push(data);
    },
    save: async function (){
      this.$_showLoading();
      let res = await this.$_api.page('form_edit', {id : this.id,form_content:this.form_content});
      if(res.errcode == 0){
        this.$_showToast(res.errmsg,res.style);
        this.get_list();
      }else{
        this.$_showToast(res.errmsg,res.style);
      }
      this.$_hideLoading();
    },
    get_list:async function (){
      if (!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.page('get_list', {page : this.page,keyword:this.keyword});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
    page_edit:function (id){
      this.$router.push({name:'one_page_detail',query: {id:id}});
    },
    show:async function (id,val){
      try {
        this.$_showLoading();
        let res = await this.$_api.page('show',{id : id, val:val});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          await this.get_list();
        }
      }catch (e){
        console.log(e);
      }
    },
    del:async function (id){
      try{
        let that = this;
        that.$_showLoading();
        let res =await that.$_api.page('del',{id:id});
        that.$_hideLoading();
        that.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          await this.get_list();
        }
      }catch (e) {
        console.log(e)
      }
    },
    bind_user:async function (id){
      try{
        console.log(id);
        if (id){
          this.$_showLoading();
          let res = await this.$_api.page('qrcode_to_bind', {id : id});
          this.$_hideLoading();
          if (res.errcode == 0){
            this.qrcode_url = res.url;
            this.is_bind = true;
          }else{
            this.$_showToastNone(res.errmsg);
          }
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    unbind_user:async function (id){
      try {
        console.log(id);
        if (id){
          this.$_showLoading();
          let res = await this.$_api.page('un_bind', {id : id});
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          if (res.errcode == 0){
            this.is_load = false;
            this.get_list();
          }
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    pop_close:function (){
      this.is_bind = false;
      this.get_list();
    },
    qrcode_save : function  (url){
      window.open(url);
    },
    send:async function (id){
      let that = this;
      console.log(id);
      let rs = await this.$_prompt('请输入次数', '提示', /^[1-9]\d*$/, '请输入大于0')
      if(rs){
        this.$_showLoading();
        let res = await
            that.$_api.admin('do_send',{one_page_id : id,uid:this.user.uid,use_num:rs,admin_id:this.user.id});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          this.get_list();
        }
      }
    },
  }
}
</script>

<style scoped>
.wx-user { display: flex;align-items: center; height: auto; overflow-x: hidden; vertical-align: middle; line-height:
    30px; }
.avatarurl { width: 30px; height: 30px; border-radius: 20px; overflow-x: hidden; background: #f2f2f2 no-repeat center; background-size: cover; }
.nickname { padding-left: 15px; font-size: 14px; line-height: 30px;flex: 1 }
.cover{width: 100px;height: 100px;background: #f2f2f2 no-repeat center;background-size: cover; }

.bg{position: fixed; z-index: 9999; left: 0; right: 0; top: 0; bottom: 0; background: rgba(0,0,0,0.2);}
.wrap{ position: fixed; z-index: 10000; width: 500px; background: #ffffff; border-radius: 5px;
  overflow:hidden; box-shadow: 0 0 30px #666666; left: 50%; top:50% ;margin-left: -250px;transform:
    translateY(-50%);}
.pop-title-closed { height: 39px; line-height: 39px; border-bottom: 1px solid #dcdfe6; padding: 0 20px; display: flex; }
.pop-title { flex: 1; padding-right: 20px; }
.pop-closed { font-size: 24px; color: #999999; cursor: pointer; }
.contain { width: 460px; padding: 20px; overflow-x: hidden; overflow-y: auto; }

.image { width: 400px; padding-bottom: 10px; margin:auto; }
.image img { width: 400px; height: 400px;}
.save { width: 120px; height: 40px; line-height: 40px; text-align: center; background: #5dbb85; color: #ffffff; border-radius: 5px; margin: auto; cursor: pointer; }
</style>